/* BOHDY site chrome, every page (layout/theme.liquid).
 *
 * 1. Announcement bar (sections/announcement-bar.liquid): rotates messages,
 *    prev/next, remembers a close per message set, and re-checks each
 *    message's start/end date in store time (the page HTML can be cached).
 * 2. Top offset for the homepage: its hero bar is position:fixed, so it is
 *    pushed down by the in-flow bars above the hero (everything marked
 *    data-top-stack) until they scroll away. Exposed on <html> as
 *    --bohdy-top-offset (what is still on screen; changes on scroll) and
 *    --bohdy-top-stack (their full height; the hero subtracts it so it
 *    still fits one screen). sections/home-hero.liquid reads both. Kept in
 *    sync on scroll, resize, message rotation and any size change of the
 *    bars (ResizeObserver: wrapping copy, font load, close).
 */
(function () {
  'use strict';

  var STORE_TZ = 'America/New_York';
  var DISMISS_KEY = 'bohdy-announce-dismissed';
  // Only bars in the header group (above the page) count; a USP strip added
  // further down a page must never pin the homepage bar.
  var TOP_STACK = '.shopify-section-group-header-group [data-top-stack]';

  function storeToday() {
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-US', { timeZone: STORE_TZ, year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date())
        .forEach(function (p) { parts[p.type] = p.value; });
      return parts.year + '-' + parts.month + '-' + parts.day;
    } catch (e) {
      return '';
    }
  }

  function initAnnouncement(bar) {
    if (bar.__bohdyInit) return;
    bar.__bohdyInit = true;
    var designMode = window.Shopify && window.Shopify.designMode;
    var today = storeToday();
    var msgs = Array.prototype.slice.call(bar.querySelectorAll('[data-announce-msg]')).filter(function (m) {
      var start = m.getAttribute('data-start');
      var end = m.getAttribute('data-end');
      var live = !today || ((!start || start <= today) && (!end || end >= today));
      if (!live && !designMode) { m.remove(); return false; }
      return true;
    });
    if (!msgs.length && !designMode) { bar.hidden = true; updateOffset(); return; }

    var prev = bar.querySelector('[data-announce-prev]');
    var next = bar.querySelector('[data-announce-next]');
    var closeBtn = bar.querySelector('[data-announce-close]');
    var index = 0;
    var timer = null;
    var paused = false;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seconds = parseInt(bar.getAttribute('data-interval'), 10) || 6;

    function show(i, animate) {
      if (!msgs.length) return;
      index = (i + msgs.length) % msgs.length;
      msgs.forEach(function (m, k) {
        m.hidden = k !== index;
        m.classList.toggle('is-entering', animate && k === index);
      });
      // Messages can differ in height (wrapping copy on phones).
      updateOffset();
    }

    function schedule() {
      window.clearInterval(timer);
      if (msgs.length < 2 || reduced || designMode) return;
      timer = window.setInterval(function () { if (!paused) show(index + 1, true); }, seconds * 1000);
    }

    if (prev) prev.hidden = msgs.length < 2;
    if (next) next.hidden = msgs.length < 2;
    if (prev) prev.addEventListener('click', function () { show(index - 1, true); schedule(); });
    if (next) next.addEventListener('click', function () { show(index + 1, true); schedule(); });
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        try { localStorage.setItem(DISMISS_KEY, bar.getAttribute('data-key')); } catch (e) {}
        bar.hidden = true;
        window.clearInterval(timer);
        updateOffset();
      });
    }

    // Theme editor: show the message being edited.
    msgs.forEach(function (m, k) {
      m.addEventListener('shopify:block:select', function () { show(k); });
    });

    show(0);
    schedule();
  }

  // Runs straight from the scroll event (two getBoundingClientRect reads):
  // a requestAnimationFrame throttle would leave the bar misplaced in tabs
  // that do not paint frames (background / embedded previews).
  var lastOffset = -1;
  var lastStack = -1;
  function updateOffset() {
    var bottom = 0;
    var stack = 0;
    Array.prototype.forEach.call(document.querySelectorAll(TOP_STACK), function (el) {
      if (el.hidden) return;
      var r = el.getBoundingClientRect();
      if (!r.height) return;
      bottom = Math.max(bottom, r.bottom);
      stack += r.height;
    });
    var offset = Math.max(0, Math.round(bottom));
    stack = Math.round(stack);
    var root = document.documentElement.style;
    if (offset !== lastOffset) { lastOffset = offset; root.setProperty('--bohdy-top-offset', offset + 'px'); }
    if (stack !== lastStack) { lastStack = stack; root.setProperty('--bohdy-top-stack', stack + 'px'); }
  }

  var resizeObserver = window.ResizeObserver ? new ResizeObserver(updateOffset) : null;
  function observeStack() {
    if (!resizeObserver) return;
    resizeObserver.disconnect();
    Array.prototype.forEach.call(document.querySelectorAll(TOP_STACK), function (el) {
      resizeObserver.observe(el);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-announce]'), initAnnouncement);
    observeStack();
    updateOffset();
  }

  window.addEventListener('scroll', updateOffset, { passive: true });
  window.addEventListener('resize', updateOffset);
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
